import React, {useState} from 'react';
import {SearchBar as AntSearchBar} from 'antd-mobile';
import {t} from "../../../../i18n";


interface SearchBarProps {
    onSearch: (value: string) => void;
}

const PickUpSearchBar: React.FC<SearchBarProps> = ({onSearch}) => {
    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (val: string) => {
        setSearchValue(val);
        onSearch(val);
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center bg-white shadow-sm rounded-lg border-1 py-0">
                <div className="flex-1">
                    <AntSearchBar
                        placeholder={t('pages.pickUp.pickingUp.searchContext')}
                        value={searchValue}
                        onChange={handleSearch}
                        style={{'--background': '#ffffff'}}
                    />
                </div>
            </div>
        </div>
    );
};

export default PickUpSearchBar;